"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPresignedUploadUrlsOutputSchema = exports.PresignedUploadSchema = exports.GetPresignedUploadUrlsInputSchema = exports.PresignedUploadItemSchema = exports.PRESIGNED_UPLOAD_URLS_MAX_ITEMS = exports.GetPresignedDownloadUrlOutputSchema = exports.GetPresignedDownloadUrlInputSchema = exports.PRESIGNED_DOWNLOAD_URL_DEFAULT_EXPIRY_SECONDS = exports.PRESIGNED_DOWNLOAD_URL_MAX_EXPIRY_SECONDS = void 0;
const zod_1 = require("zod");
exports.PRESIGNED_DOWNLOAD_URL_MAX_EXPIRY_SECONDS = 900;
exports.PRESIGNED_DOWNLOAD_URL_DEFAULT_EXPIRY_SECONDS = 300;
exports.GetPresignedDownloadUrlInputSchema = zod_1.z.object({
    location: zod_1.z.string().min(1).max(2048),
    grant: zod_1.z.string().min(1).max(16384),
    expirySeconds: zod_1.z.number().int().min(1).max(exports.PRESIGNED_DOWNLOAD_URL_MAX_EXPIRY_SECONDS).optional(),
});
exports.GetPresignedDownloadUrlOutputSchema = zod_1.z.object({
    url: zod_1.z.string().url(),
    expiresAt: zod_1.z.string().datetime(),
});
exports.PRESIGNED_UPLOAD_URLS_MAX_ITEMS = 64;
exports.PresignedUploadItemSchema = zod_1.z.object({
    location: zod_1.z.string().min(1).max(2048),
    contentType: zod_1.z.string().min(1).max(256),
});
exports.GetPresignedUploadUrlsInputSchema = zod_1.z.object({
    items: exports.PresignedUploadItemSchema.array().min(1).max(exports.PRESIGNED_UPLOAD_URLS_MAX_ITEMS),
    grant: zod_1.z.string().min(1).max(16384),
    expirySeconds: zod_1.z.number().int().min(1).max(exports.PRESIGNED_DOWNLOAD_URL_MAX_EXPIRY_SECONDS).optional(),
});
exports.PresignedUploadSchema = zod_1.z.object({
    location: zod_1.z.string(),
    url: zod_1.z.string().url(),
    headers: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
});
exports.GetPresignedUploadUrlsOutputSchema = zod_1.z.object({
    uploads: exports.PresignedUploadSchema.array(),
    expiresAt: zod_1.z.string().datetime(),
});
//# sourceMappingURL=internal-files.types.js.map